// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import rate from 'vue-rate'
import App from './App'
import router from './router'
import store from './store'
import messages from '@/constants/messages'
import rotas from '@/constants/rotas'
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/pt-br'
import modulo from '@/utils/modulo'
import permissao from '@/utils/permissao'
import VueFormGeneratorElement from 'vue-form-generator-element-gt4w'
import AppTextArea from '@/components/AppTextArea'
import AppListagemLimites from '@/components/AppListagemLimites'
import {
  Button,
  Card,
  Col,
  Collapse,
  CollapseItem,
  Checkbox,
  Dialog,
  Row,
  Upload,
  Submenu,
  Menu,
  MenuItem,
  MessageBox,
  Loading,
  Container,
  Header,
  Main,
  Footer,
  Table,
  TableColumn,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Pagination,
  Steps,
  Step,
  TabPane,
  Tabs,
  Tooltip,
  Dropdown,
  DropdownMenu,
  RadioGroup,
  Divider,
  Radio,
  InputNumber,
  DatePicker,
  DropdownItem,
  Alert,
  RadioButton,
  OptionGroup,
  Tag,
  Avatar,
  Progress,
  Badge,
  Popover,
  Image,
  Switch,
  Carousel,
  CarouselItem
} from 'element-ui'

import VueProgressBar from 'vue-progressbar'
// import de estilos
import './assets/styles/element-variables.scss'
import 'material-design-icons/iconfont/material-icons.css'
import './assets/styles/main.scss'
import './assets/styles/theme/display.css'

import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import 'leaflet/dist/leaflet.css'

import VueTheMask from 'vue-the-mask'

import 'vue-awesome/icons'
import IconVue from 'vue-awesome/components/Icon'

import '@fortawesome/fontawesome-pro'
import '@fortawesome/fontawesome-pro/css/all.css'

import vueDebounce from 'vue-debounce'

// FONTAWESOME
import { library } from '@fortawesome/fontawesome-svg-core'

import VueTrumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css' // eslint-disable-line
import 'trumbowyg/dist/langs/pt_br' // eslint-disable-line
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'

import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import InformarDadosMA from '@/screens/analise/vtn/components/InformarDadosMa.vue'
import AppDivider from '@/components/AppDivider'

import {
  faDownload,
  faCloudDownloadAlt,
  faCheck,
  faTimes,
  faCommentAlt,
  faPlus,
  faEnvelope,
  faChartBar,
  faClock,
  faDollarSign,
  faFileAlt,
  faMap,
  faHandHoldingUsd,
  faFile,
  faUserCircle,
  faSignOutAlt,
  faMinus,
  faBan,
  faKey,
  faSave,
  faChevronRight,
  faChevronLeft,
  faEye,
  faFolderOpen,
  faExclamationTriangle,
  faPager,
  faExternalLinkAlt,
  faLink,
  faSync,
  faComments,
  faSearch,
  faShareSquare,
  faTrash,
  faBell,
  faEdit,
  faPencilAlt,
  faCrosshairs,
  faUpload,
  faCreditCard,
  faQuestionCircle,
  faUserFriends,
  faHdd,
  faBug,
  faEnvelopeOpen,
  faFileInvoiceDollar,
  faFileSignature,
  faAward,
  faChartLine,
  faBalanceScale,
  faHourglassHalf,
  faTag,
  faTags,
  faInfoCircle,
  faCompressArrowsAlt,
  faBookmark,
  faBoxOpen,
  faFilePdf,
  faHistory,
  faUnlockAlt,
  faMobileAlt,
  faMapMarkerAlt,
  faAddressCard,
  faBuilding,
  faPhoneSquare,
  faGlobeAmericas,
  faCloudUploadAlt,
  faPaperPlane,
  faBars,
  faExclamationCircle,
  faArrowRight,
  faArchive,
  faFileArchive,
  faUserEdit,
  faUserPlus,
  faUsers,
  faUser,
  faFileContract,
  faFileExport,
  faHourglassStart,
  faImage,
  faSignature,
  faCalculator,
  faCode,
  faFileExcel,
  faPrint,
  faAngleDoubleRight,
  faFileCsv,
  faFileDownload,
  faPauseCircle,
  faPenSquare,
  faPowerOff,
  faEllipsisV,
  faCircle,
  faArrowAltCircleDown,
  faArrowsAlt
} from '@fortawesome/free-solid-svg-icons'

import { faWindows, faLinux } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import carregarExtends from '@/utils/veeValidate'
import '@/directives/rotate'
import utils from '@/utils/utils'

import 'summernote/dist/summernote-lite'
import './assets/summernote/text-editor-style.scss'
import './assets/summernote/summernote-pt-BR'

import VueSanitize from 'vue-sanitize'

import VueScrollTo from 'vue-scrollto'

import VueMask from 'di-vue-mask'

Vue.use(VueMask)

Vue.use(Donut)

Vue.use(VueSanitize)

Vue.use(VueToastr)
Vue.use(VueFormGeneratorElement)
Vue.use(rate)
Vue.use(Card)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(Checkbox)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Upload)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Loading)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Button)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(VueTheMask)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Checkbox)
Vue.use(Divider)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(VueTrumbowyg)
Vue.use(DropdownItem)
Vue.use(Alert)
Vue.use(RadioButton)
Vue.use(OptionGroup)
Vue.use(Tag)
Vue.use(Avatar)
Vue.use(Progress)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Switch)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.use(VueProgressBar, {
  color: '#009f61',
  failedColor: 'red',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 600
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
  autoFinish: false
})

Vue.use(VueScrollTo, {
  container: '.content',
  duration: 500,
  easing: 'ease',
  cancelable: false,
  x: false,
  y: true
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('icon', IconVue)

Vue.component('field-app-text-area', AppTextArea)
Vue.component('field-app-listagem-limites', AppListagemLimites)
Vue.component('app-modal-visualizar-completo', AppModalVisualizarCompleto)
Vue.component('app-divider', AppDivider)
Vue.component('informar-dados-ma', InformarDadosMA)

Vue.use(vueDebounce)

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
  faExternalLinkAlt,
  faSave,
  faChevronRight,
  faChevronLeft,
  faEye,
  faFolderOpen,
  faBan,
  faPager,
  faSync,
  faComments,
  faSearch,
  faShareSquare,
  faExclamationTriangle,
  faTrash,
  faFileCsv,
  faFileDownload,
  faArrowAltCircleDown
)
library.add(faDownload, faCheck, faTimes, faPlus, faCommentAlt, faMinus)

library.add(
  faEnvelope,
  faChartBar,
  faClock,
  faDollarSign,
  faFileAlt,
  faMap,
  faFile,
  faHandHoldingUsd,
  faPauseCircle,
  faPenSquare
)
library.add(
  faUserCircle,
  faSignOutAlt,
  faCloudDownloadAlt,
  faLink,
  faEdit,
  faBell,
  faKey,
  faPencilAlt,
  faCrosshairs,
  faUpload,
  faCreditCard,
  faQuestionCircle,
  faUserFriends
)
library.add(
  faEnvelope,
  faChartBar,
  faClock,
  faDollarSign,
  faFileAlt,
  faMap,
  faFile,
  faHourglassHalf,
  faTag,
  faTags,
  faInfoCircle,
  faCompressArrowsAlt,
  faBookmark
)
library.add(
  faEnvelopeOpen,
  faHdd,
  faFileInvoiceDollar,
  faFileSignature,
  faAward,
  faChartLine,
  faBalanceScale,
  faBoxOpen
)
library.add(
  faUserCircle,
  faSignOutAlt,
  faCloudDownloadAlt,
  faLink,
  faEdit,
  faBell,
  faKey,
  faPencilAlt,
  faCrosshairs,
  faUpload,
  faCreditCard,
  faQuestionCircle
)
library.add(
  faDownload,
  faCheck,
  faTimes,
  faPlus,
  faCommentAlt,
  faMinus,
  faHistory
)
library.add(
  faEnvelope,
  faChartBar,
  faClock,
  faDollarSign,
  faFileAlt,
  faMap,
  faFile,
  faUnlockAlt
)
library.add(
  faUserCircle,
  faSignOutAlt,
  faCloudDownloadAlt,
  faLink,
  faEdit,
  faBell,
  faKey,
  faPencilAlt,
  faCrosshairs,
  faUpload,
  faCreditCard,
  faQuestionCircle,
  faFilePdf,
  faUserFriends,
  faArrowsAlt
)

library.add(
  faArrowRight,
  faAddressCard,
  faBuilding,
  faPhoneSquare,
  faGlobeAmericas,
  faCloudUploadAlt,
  faPaperPlane,
  faBars,
  faExclamationCircle,
  faCode,
  faFileExcel,
  faAngleDoubleRight,
  faPrint
)
library.add(faWindows, faLinux, faBug, faMobileAlt, faUser, faMapMarkerAlt)
library.add(
  faArchive,
  faFileArchive,
  faUserEdit,
  faUserPlus,
  faUsers,
  faFileContract,
  faFileExport,
  faHourglassStart,
  faImage,
  faSignature,
  faCalculator,
  faPowerOff,
  faEllipsisV,
  faCircle
)

carregarExtends()

locale.use(lang)

Vue.filter('formatDouble', (val, precision = 2) =>
  utils.format(val, {
    prefix: '',
    suffix: '',
    thousands: '.',
    decimal: ',',
    precision
  })
)

var filter = function (text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter('truncate', filter)

// Adição de constantes
Vue.prototype.$messages = messages
Vue.prototype.$modulo = modulo
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$rotas = rotas
Vue.prototype.$permissao = permissao

Vue.config.productionTip = false

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js